import script from "./QuickTrade.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickTrade.vue?vue&type=script&setup=true&lang=js"

import "./QuickTrade.vue?vue&type=style&index=0&id=7f7d4718&lang=less"

const __exports__ = script;

export default __exports__